const parseArg = <T>(key: string, defaultValue: T): T => {
  const arg = process.env[key];
  if (arg === undefined) {
    return defaultValue;
  }
  try {
    return JSON.parse(arg);
  } catch {
    return defaultValue;
  }
};

/**
 * Use this argument to store get requests in local storage and re-use the value
 */
export const offline = parseArg('REACT_APP_ARG_OFFLINE', false);
